import React, { useState } from "react";
import { Modal, Tabs } from "antd";
import BaseButton from "../../Button/BaseButton";
import { useTranslation } from "react-i18next";
import "../../../../assets/style/modalStyle/postNews.scss";
import { useDispatch, useSelector } from "react-redux";
import { getDetailPostNews } from "../../../../services/slice/NewsSlice";
import {
  newsSelector,
  pupSelector,
} from "../../../../services/selector/index.";
import { setStatePUEdit } from "../../../../services/slice/PopUpSlice";
import { useEffect } from "react";
import { editPostNews } from "../../../../services/slice/NewsSlice";
import TabEditNews from "../../Tabs/TabEditNews";
import { IconSave } from "../../../../assets/icon";
import { log } from "util";
import { login } from "../../../../services/slice/AuthSlice";
import { validateUrl } from "../../../../utils/functionCommon";

const ModalEditNews = ({ titleText }) => {
  const stateNews = useSelector(newsSelector);
  const { detailByID } = stateNews;
  const [datapost, setDataPost] = useState({
    title: "",
    descriptions: "",
    content: "",
    typePost: "",
    urlImage: "",
    largeImage: "",
    lastUpdate: 0,
  });
  const [defaultValue, setDefaultValue] = useState("");
  useEffect(() => {
    setDefaultValue(datapost.typePost);
  }, [datapost.typePost]);

  useEffect(() => {
    setDataPost({
      ...datapost,
      id: detailByID?.id,
      title: detailByID?.title,
      descriptions: detailByID?.descriptions,
      content: detailByID?.content,
      typePost: detailByID?.typePost,
      urlImage: detailByID?.urlImage,
      largeImage: detailByID?.largeUrlImage,
      categories: detailByID?.categories,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [detailByID]);

  const statePU = useSelector(pupSelector);
  const { dataEdit } = statePU;
  const [image, setImage] = useState("");
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [error, setError] = useState({
    isError: false,
    msg: "",
  });
  const handleSave = () => {
    if (
      !datapost.title ||
      datapost.content === "<p><br></p>" ||
      !datapost.content ||
      !datapost.descriptions ||
      !datapost.typePost
    ) {
      setError({
        isError: true,
        msg: "Vui lòng nhập đầy đủ thông tin",
      });
      return;
    }
    if (
      datapost.typePost === 2 &&
      datapost.content &&
      !validateUrl(datapost.content)
    ) {
      setError({
        isError: true,
        msg: "Đường dẫn không hợp lệ",
      });
      return;
    }
    // if (image.size > 2 * 1024 * 1024) {
    //   setError({
    //     isError: true,
    //     msg: "Dung lượng ảnh phải nhỏ hơn < 2MB",
    //   });
    //   return;
    // }

    setError({
      isError: false,
      msg: "",
    });
    const formPost = new FormData();
    if (datapost.urlImage.type) {
      formPost.append("smallImage ", datapost.urlImage);
    }
    if (datapost.largeImage.type) {
      formPost.append("largeImage ", datapost.largeImage);
    }
    formPost.append("id", datapost.id);
    formPost.append("title", datapost.title);
    formPost.append("categories", datapost.categories);
    formPost.append("descriptions", datapost.descriptions);
    formPost.append("lastUpdate", datapost.lastUpdate);
    formPost.append(
      "content",
      datapost.content.replace(
        new RegExp(window.SERVER_URL, "g"),
        window.SERVER_CLIENT_URL
      )
    );
    formPost.append("typePost", datapost.typePost);

    dispatch(editPostNews(formPost));
    handleCancel();
  };
  const { isOpenPUEdit, contentEdit } = dataEdit;
  const handleCancel = () => {
    dispatch(setStatePUEdit({ stateOpen: false, content: "" }));
  };
  useEffect(() => {
    dispatch(getDetailPostNews(contentEdit.iden));
  }, [contentEdit.iden, dispatch]);
  const handleChangeTabs = (key) => {
    setDataPost({ ...datapost, typePost: key });
  };
  return (
    <>
      <Modal
        maskClosable={false}
        className="wrapperModalPostNews"
        title={t(titleText)}
        centered
        width={1300}
        open={isOpenPUEdit}
        onCancel={handleCancel}
        footer={[
          <BaseButton
            content={"Lưu"}
            typeBtn="btnOrange"
            icon={<IconSave />}
            width={96}
            handleClick={handleSave}
          />,
        ]}
      >
        <Tabs
          key={defaultValue}
          defaultActiveKey={defaultValue}
          activeKey={datapost.typePost?.toString()}
          onChange={handleChangeTabs}
          items={[
            {
              label: t("Viết bài"),
              key: "1",
              children: (
                <TabEditNews
                  img={image}
                  error={error}
                  datapost={datapost}
                  setDataPost={setDataPost}
                  setImage={setImage}
                />
              ),
            },
            {
              label: t("Nhập link"),
              key: "2",
              children: (
                <TabEditNews
                  img={image}
                  error={error}
                  datapost={datapost}
                  setDataPost={setDataPost}
                  setImage={setImage}
                />
              ),
            },
          ]}
        />
      </Modal>
    </>
  );
};

export default ModalEditNews;
